export default class SectionComponent extends HTMLElement {

    get navigation() {
        return this.querySelector("nav");
    }

    get content() {
        return this.querySelector("section.content");
    }

    get instructions() {
        return this.querySelector("section.instructions");
    }

    constructor() {
        super();
        this.innerHTML = `
            <section class="instructions" aria-label="section-instructions">
            </section>
            <section class="content" aria-label="section-content">
            </section>
            <nav aria-label="section-navigation">
            </nav>
        `;
    }

    setInstructions(instructionsHtml) {
        this.instructions.innerHTML = instructionsHtml;
    }

    setContent(contentHtml) {
        this.content.innerHTML = contentHtml;
    }

    appendChild(child) {
        return this.content.appendChild(child);
    }

}